import React from "react";
var __jsx = React.createElement;
import TokenLogo from "../../../TokenLogo";
import styled from 'styled-components';

var TokenInput = _ref => {
  var symbol = _ref.symbol,
      logo = _ref.logo,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      onClick = _ref.onClick;
  return __jsx(StyledTokenWrapper, {
    onClick: onClick,
    isSelected: isSelected,
    wrap: wrap
  }, __jsx(TokenLogo, {
    large: true,
    space: 0,
    logo: logo,
    symbol: symbol
  }), __jsx("span", null, symbol));
};

export default TokenInput;
var StyledTokenWrapper = styled.div.withConfig({
  displayName: "StyledTokenWrapper",
  componentId: "sc-1jhke6s-0"
})(["display:flex;align-items:center;gap:10px;width:100%;height:56px;padding:0 24px;border:2px solid #e2e5f1;border-color:", ";border-radius:56px;background:#fff;cursor:pointer;font-size:16px;font-weight:600;line-height:140%;color:", ";", ""], _ref2 => {
  var isSelected = _ref2.isSelected;
  return isSelected ? '#5F4DBC' : '#B9BED3';
}, _ref3 => {
  var isSelected = _ref3.isSelected;
  return isSelected ? '#5F4DBC' : '#5A5D6D';
}, _ref4 => {
  var wrap = _ref4.wrap;
  return wrap && "\n      width: auto;\n    ";
});